module.exports = __webpack_public_path__ + "img/jianjie@2x.2484b8c2.png";